import { useState, useEffect, useRef, useCallback } from "react";

export function useRecordingTimer(recording: boolean) {
  const [seconds, setSeconds] = useState(0);
  const wasRecordingRef = useRef(false);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    if (recording) {
      if (!wasRecordingRef.current) {
        setSeconds(0);
      }
      wasRecordingRef.current = true;
      interval = setInterval(() => {
        setSeconds((s) => s + 1);
      }, 1000);
    } else {
      wasRecordingRef.current = false;
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [recording]);

  const resetTimer = useCallback(() => {
    setSeconds(0);
  }, []);

  const formatTime = (totalSeconds: number) => {
    const m = Math.floor(totalSeconds / 60).toString().padStart(2, "0");
    const s = (totalSeconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  return { seconds, formattedTime: formatTime(seconds), resetTimer };
}
